const API_BASE_URL = process.env.VUE_APP_GLOBAL_URL;
const VUE_APP_FRONT_GLOBAL_URL = process.env.VUE_APP_FRONT_GLOBAL_URL;
const OAUTH2_REDIRECT_URI = VUE_APP_FRONT_GLOBAL_URL + '/oauth2/result';
const proPrice = process.env.VUE_APP_PRO_FEE_AMOUNT;

export default Object.freeze({
    SESSION_STORAGE_TOKEN: 'astro_token',
    SESSION_STORAGE_REDIRECT: 'astro_redirect',

    ACCEPT_COOKIE_NAME: 'astro_accept_cookie',
    TRIAL_WINDOW_EMAIL_COOKIE_NAME: 'astro_trial_window',

    ACCESS_TOKEN: 'accessToken',
    // GOOGLE_AUTH_URL: API_BASE_URL + '/oauth2/authorize/google',
    // FACEBOOK_AUTH_URL: API_BASE_URL + '/oauth2/authorize/facebook',
    // VK_AUTH_URL: API_BASE_URL + '/oauth2/authorize/vk',
    GOOGLE_AUTH_URL: API_BASE_URL + '/oauth2/authorize/google?redirect_uri=' + OAUTH2_REDIRECT_URI,
    FACEBOOK_AUTH_URL: API_BASE_URL + '/oauth2/authorize/facebook?redirect_uri=' + OAUTH2_REDIRECT_URI,
    VK_AUTH_URL: API_BASE_URL + '/oauth2/authorize/vk?redirect_uri=' + OAUTH2_REDIRECT_URI,

    tariff: {
        STANDARD: 'STANDARD',
        PRO: 'PRO',
        TRIAL: 'TRIAL'
    },

    price:{
      PRO: proPrice
    },

    yandexMoney: {
        paymentTypes: {
            wallet: 'PC',
            card: 'AC'
        }
    },

    openCage: {
        key: encodeURIComponent('d7eb0814a7004ed49ac2878c0d7d012a'),
        url: 'https://api.opencagedata.com/geocode/v1/json',
        allowedTypes: [
            'city',
            'village',
            'county',
            'neighbourhood',
            'state_district',
            'state'
        ]
    },

    articleStatus: {
        FOR_ALL: 'FOR_ALL',
        ONLY_AUTH: 'ONLY_AUTH',
        ONLY_PAID: 'ONLY_PAID',
        ONLY_PRO: 'ONLY_PRO'
    },

    mode: {
        natal: 'natal',
        design: 'design',
        transit: 'transit',
        direction: 'direction',
        progression: 'progression',
        multimap: 'multimap'
    },

    gateLongitudes: [223.25, 43.25, 26.375, 138.875, 251.375, 172.625, 133.25, 54.5, 245.75, 268.25, 262.625, 82.625, 313.25, 234.5, 88.25, 65.75, 3.875, 183.875, 307.625, 60.125, 9.5, 347, 48.875, 37.625, 358.25, 257, 32, 212, 144.5, 324.5, 122, 200.75, 127.625, 240.125, 71.375, 352.625, 335.75, 279.5, 99.5, 155.75, 302, 20.75, 228.875, 217.625, 77, 178.25, 167, 189.5, 318.875, 206.375, 15.125, 93.875, 105.125, 285.125, 330.125, 116.375, 195.125, 273.875, 150.125, 296.375, 290.75, 110.75, 341.375, 161.375],

    zodiacs: ['ARIES', 'TAURUS', 'GEMINI', 'CANCER', 'LEO', 'VIRGO', 'LIBRA', 'SCORPIO', 'SAGITTARIUS', 'CAPRICORN', 'AQUARIUS', 'PISCES'],

    planets: ['SUN', 'EARTH', 'MOON', 'TRUE_NODE', 'MEAN_NODE', 'MERCURY', 'VENUS', 'MARS', 'JUPITER', 'SATURN', 'URANUS', 'NEPTUNE', 'PLUTO', 'LILITH'],

    aspectPlanets: ['SUN', 'MOON', 'MERCURY', 'VENUS', 'MARS', 'JUPITER', 'SATURN', 'URANUS', 'NEPTUNE', 'PLUTO', 'TRUE_NODE', 'MEAN_NODE', 'LILITH'],

    firdarPlanets: ['SUN', 'MOON', 'MERCURY', 'VENUS', 'MARS', 'JUPITER', 'SATURN', 'TRUE_NODE', 'MEAN_NODE'],

    aspectHouseCusps: ['I', 'II', 'III', 'IV', 'V', 'VI'],

    /**
     * Планеты, отображаемые в таблицах "Личность" и "Дизайн"
     */
    natalDesignPlanets: ['SUN', 'EARTH', 'MOON', 'TRUE_NODE', 'MEAN_NODE', 'MERCURY', 'VENUS', 'MARS', 'JUPITER', 'SATURN', 'URANUS', 'NEPTUNE', 'PLUTO'],

    planetNames: new Map([
        ['SUN', 'Солнце'],
        ['EARTH', 'Земля'],
        ['MOON', 'Луна'],
        ['TRUE_NODE', 'Северный узел'],
        ['MEAN_NODE', 'Южный узел'],
        ['MERCURY', 'Меркурий'],
        ['VENUS', 'Венера'],
        ['MARS', 'Марс'],
        ['JUPITER', 'Юпитер'],
        ['SATURN', 'Сатурн'],
        ['URANUS', 'Уран'],
        ['NEPTUNE', 'Нептун'],
        ['PLUTO', 'Плутон'],
        ['LILITH', 'Лилит']
    ]),

    modeNames: new Map([
        ['natal', 'Личность'],
        ['design', 'Дизайн'],
        ['transit', 'Транзит'],
        ['direction', 'Дирекция'],
        ['progression', 'Прогрессия'],
        ['multimap', 'Мультикарта']
    ]),

    typeNames: new Map([
        ['GENERATOR', 'Генератор'],
        ['PROJECTOR', 'Проектор'],
        ['MANIFESTOR', 'Манифестор'],
        ['REFLECTOR', 'Рефлектор'],
        ['MANIFESTING_GENERATOR', 'Манифестирующий генератор']
    ]),

    profiles: new Map([
        ['1/3', 'Исследователь - Мученик'],
        ['1/4', 'Исследователь - Оппортунист'],
        ['2/4', 'Отшельник - Оппортунист'],
        ['2/5', 'Отшельник - Еретик'],
        ['3/5', 'Мученик - Еретик'],
        ['3/6', 'Мученик - Ролевая модель'],
        ['4/6', 'Оппортунист - Ролевая модель'],
        ['4/1', 'Оппортунист - Исследователь'],
        ['5/1', 'Еретик - Исследователь'],
        ['5/2', 'Еретик - Отшельник'],
        ['6/2', 'Ролевая модель - Отшельник'],
        ['6/3', 'Ролевая модель - Мученик']
    ]),

    authorityNames: new Map([
        ['EMOTIONAL', 'Эмоциональный'],
        ['SACRAL', 'Сакральный'],
        ['SPLEEN', 'Селезёночный'],
        ['EGO_MANIFEST', 'Эго-манифестируемый'],
        ['EGO_PROJECTION', 'Эго-проецируемый'],
        ['SELF_PROJECTION', 'Самопроецируемый'],
        ['NONE', 'Без внутреннего авторитета'],
        ['MOON', 'Лунный']
    ]),

    tariffNames: new Map([
        ['STANDARD', 'Базовый'],
        ['PRO', 'PRO'],
        ['TRIAL', 'Пробный']
    ]),

    dictionary: {
        custom: {
            email: {
                required: 'Введите адрес электронной почты',
                email: 'Введите адрес электронной почты'
            }
        }
    }
});